exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".tile[data-v-5ff8b749]{width:100%;flex:auto;flex-wrap:wrap;position:relative;overflow:hidden;margin:1px;cursor:pointer}.tile:hover .tile__description[data-v-5ff8b749]{transform:translateY(-2rem)}.tile__description[data-v-5ff8b749]{width:100%;position:absolute;bottom:-2rem;left:0;padding:.5rem;color:#fff;background:rgba(0,0,0,.4);text-overflow:ellipsis;overflow:hidden;white-space:nowrap;height:2rem;transition:all 275ms;font-size:1rem;line-height:1rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"id":"data-v-5ff8b749","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/custom/tile.vue
// module id = 125
// module chunks = 4